import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { CustomerGroupModel } from '../models/customer-group.model';

export class CustomerGroupsApiService extends ApiService {
  static endpoint = 'customer-groups';

  /**
   * @param {Number|null} customerGroupId
   * @return {String}
   * @protected
   */
  static buildCustomerGroupUrl(customerGroupId = null) {
    return this.buildUrl(customerGroupId);
  }

  /**
   * @param {String|Number} customerGroupId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CustomerGroupModel>>}
   * @public
   */
  static async get(customerGroupId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildCustomerGroupUrl(customerGroupId), {
      ...config,
      dataModel: CustomerGroupModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String} customerGroupId
   * @param {builderCallback|null} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CustomerGroupModel>>}
   * @public
   */
  static getAll(builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildCustomerGroupUrl(), {
      ...config,
      dataModel: CustomerGroupModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CustomerGroupModel>>}
   * @public
   */
  static async post(data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildCustomerGroupUrl(), data, {
      ...config,
      dataModel: CustomerGroupModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} customerGroupId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<CustomerGroupModel>>}
   * @public
   */
  static async patch(customerGroupId, data = {}, builderCallback = null, config = {}) {
    return HttpApiClient.patch(this.buildCustomerGroupUrl(customerGroupId), data, {
      ...config,
      dataModel: CustomerGroupModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} customerGroupId
   * @param {Object} config
   * @return {Promise<HttpResponse>}
   * @public
   */
  static async delete(customerGroupId, config = {}) {
    return HttpApiClient.delete(this.buildCustomerGroupUrl(customerGroupId), { ...config });
  }
}
